import { z } from 'zod';
import { isoDateTimeSchema, ulidSchema } from '../common.js';

/**
 * One thing somebody did. Written everywhere, read by the bell.
 *
 * Append-only and trimmed by the table's TTL at 180 days: this is a feed, not an
 * audit log that has to survive a subpoena.
 */
export const activitySchema = z.object({
  type: z.literal('Activity'),
  wedId: ulidSchema,
  userId: z.string().max(64),
  /** `created`, `updated`, `reviewed`, `paid`, … */
  action: z.string().max(40),
  /** `Venue`, `Guest`, `Task`, … */
  entity: z.string().max(40),
  entityId: z.string().max(64),
  /** What it was — a venue's name, a task's title. */
  summary: z.string().max(300).optional(),
  createdAt: isoDateTimeSchema,
});
export type Activity = z.infer<typeof activitySchema>;
